export const validatePassword = (input) => {
  console.log('validatePassword called', input)

  if (input.length < 7) {
    return false
  } else {
    return true
  }
};
